function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { themeToCssVars, setRootTheme, removeRootTheme } from './utils';
import { THEME_PROP_TYPE } from './constants';

var Theme =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Theme, _React$Component);

  function Theme() {
    _classCallCheck(this, Theme);

    return _possibleConstructorReturn(this, _getPrototypeOf(Theme).apply(this, arguments));
  }

  _createClass(Theme, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          isRoot = _this$props.isRoot,
          theme = _this$props.theme;

      if (isRoot) {
        setRootTheme(theme);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevTheme = _ref.theme,
          prevWasRoot = _ref.isRoot;
      var _this$props2 = this.props,
          newIsRoot = _this$props2.isRoot,
          newTheme = _this$props2.theme;

      if (prevWasRoot || newIsRoot) {
        // If at any time we had a root theme (either before or after)
        // we should remove the previous theme just to be safe. This
        // may result in the same root theme being removed and added,
        // but this is safest for all of the edge cases (shown in unit tests)
        removeRootTheme(prevTheme); // Now if we want to display a root theme, set it

        if (newIsRoot) {
          setRootTheme(newTheme);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          isRoot = _this$props3.isRoot,
          theme = _this$props3.theme;

      if (isRoot) {
        removeRootTheme(theme);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          theme = _this$props4.theme,
          children = _this$props4.children,
          isRoot = _this$props4.isRoot;
      var style = isRoot ? {} : themeToCssVars(theme); // Call render prop to render UI, passing style as "theme prop"

      return children({
        style: style
      });
    }
  }]);

  return Theme;
}(React.Component);

_defineProperty(Theme, "propTypes", {
  children: PropTypes.func.isRequired,
  theme: THEME_PROP_TYPE,
  isRoot: PropTypes.bool
});

_defineProperty(Theme, "defaultProps", {
  isRoot: false
});

export { Theme as default };